import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure} from "@nextui-org/react";
import {Input, Spin} from 'antd';
import { baseUrlLink } from "../../../../utils/types";
import axios from "axios";
import {belen_uri} from "../../../../utils/url";
import { toast } from "react-toastify";

export default function OrderCompletedModal({data, callback}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [load, setLoad] = useState(false);
//   const [pay, setPay] = useState();

  const Call = () => {
    callback();
  }

  const Submit = async () => {
    setLoad(true);
    try{
        const res = await axios.patch(belen_uri+`/admin/complete`, {id: data.id});
        if(res.status === 200){
            toast.success("Амжилттай");
            onOpenChange(false);
            Call();
        }
        setLoad(false);
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }

  return (
    <>
      <Button size="sm" onPress={onOpen}>Захиалсан бараа</Button>
      <Modal size="xl" isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Барааны жагсаалт</ModalHeader>
              <ModalBody>
                <div>
                  {
                    data.userToCartItem.map((it, index)=>{
                      return(
                        <div className="mt-1">
                          <div className="flex items-center gap-2">
                            <img className="h-32 w-28" src={baseUrlLink+it.belenBaraa.belenbaraa_to_image[0].image}/>
                            <div>
                              <h1>{it.belenBaraa.title}</h1>
                              <h1>{it.belenBaraa.desc}</h1>
                              <h1 className="font-bold">{it.quantity}</h1>
                              {
                                it.sizeId != 63 &&
                                <h1 className="font-bold">Size: {it.size.size}</h1>
                              }
                            </div>
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
                {
                    load?
                    <Button color="primary">
                        <Spin/>
                    </Button>
                    :
                    <Button color="" onPress={Submit}>
                        Баталгаажуулах
                    </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
